import { useQuery } from "@tanstack/react-query";
import { BPLocaleSelector } from "./BPLocaleSelector";
import { authClient } from "../../Auth";
import { Container, Grid, GridColumn, Segment } from "@/components/bp/bp-ui";
import { BPContainer } from "@/components/bp/bpcontainer";

export const BPFooter: React.FC = () => {
    const appInfo = useQuery({
        queryKey: ["appInfo"],
        queryFn: async () => {
            return await authClient.getAppInfo();
        }
    });

    if (appInfo.isLoading || appInfo.isError) {
        return <div></div>;
    }

    return (
        <Segment basic className="footer height">
            <BPContainer>
                <Grid stackable className="buildinfo">
                    <GridColumn width={8} verticalAlign="middle">
                        {appInfo.data?.buildString}
                        &nbsp;|&nbsp;
                        <BPLocaleSelector />
                    </GridColumn>
                </Grid>
            </BPContainer>
        </Segment>
        // <div className="ui basic segment footer">
        //     <div className="ui container">
        //         <div className="ui equal height stackable grid">
        //             <div className="eight wide column">
        //                 <div className="buildinfo">
        //                     @Html.Raw(Settings.BuildString)
        //                     |
        //                     <div className="ui dropdown" data-component="localeselector" data-localeselector-cookie="@cookieProvider.CookieName">
        //                         <input type="hidden" name="cultureName" value="@(usedLocaleCookie ? CultureInfo.CurrentCulture.Name : "")" />
        //                         <div className="text">@CultureInfo.CurrentCulture.NativeName</div>
        //                         <i className="dropdown icon"></i>
        //                         <div className="menu">
        //                             <div className="item" data-value="">@CommonStrings.GetString(r => r.Default) (@CultureInfo.CurrentCulture.NativeName)</div>
        //                         @foreach (var l in LocOptions.Value.SupportedCultures.OrderBy(l => l.NativeName))
        //                             {
        //                                 <div className="item" data-value="@l.Name">@l.NativeName</div>
        //                             }
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //             @if (showCredits)
        //             {

        //             }
        //         </div>
        //     </div>
        // </div>
    );
};